export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
    }
  },
  API: {
    REST: {
      VoiceNotesAPI: {
        endpoint: import.meta.env.VITE_API_URL,
        region: 'us-east-1'
      }
    }
  }
};
